<template>
    <a :href="link" class="journey-card">
        <div class="journey-card__content">
            <div class="journey-card__details">
                <h5 class="journey-card__title">{{ title }}</h5>
                <p class="journey-card__summary">{{ summary }}</p>
            </div>
            <button
                @click="handleClick"
                class="journey-card__button button-ghost-dark button-icon"
            >
                <journey-icon></journey-icon>
                Add journey
            </button>
        </div>
        <div class="journey-card__image" :style="'background-image:url('+image+')'"></div>
        <div class="journey-card__days">
            <span class="journey-card__days-count">{{ days.length }}</span>
            <span class="journey-card__days-text">Days</span>
        </div>
    </a>
</template>
<script>
import JourneyIcon from "@/vue/icons/JourneyIcon";
import { useModalStore } from "@/vue/stores/modal";
import { useTripStore } from "@/vue/stores/trip";
import Confirmation from "@/vue/components/Confirmation";

export default {
    components: {
        JourneyIcon,
    },
    props: {
        days: Array,
        link: String,
        title: String,
        summary: String,
        image: String,
    },
    data() {
        return {
            modal: useModalStore(),
            trip: useTripStore(),
        };
    },
    methods: {
        handleClick: function (e) {
            e.preventDefault();
            window.scrollTo(0, 0) 

            if (!this.trip.hasListings()) {
                this.handleConfirm(this.days);
                return;
            }

            this.modal.open(Confirmation, {
                message: "This will overwrite your current journey.",
                options: [
                    {
                        text: "Yes - Overwrite my journey",
                        classList: "button-solid-dark",
                        handler: this.handleConfirm,
                        args: this.days,
                    },
                    {
                        text: "Cancel - Keep my current journey",
                        classList: "button-solid-red",
                        handler: this.handleCancel,
                    },
                ],
            });
        },
        handleConfirm(data) {
            this.trip.replaceData(data);
            this.modal.close();
        },
        handleCancel() {
            this.modal.close();
        },
    },
};
</script>
<style lang="scss">
.journey-card {
    position: relative;
    display: grid;
    background-color: #f6f8fb;
    grid-template-columns: auto;

    @media (min-width: 1024px) {
    }

    @media (min-width: 1280px) {
        grid-template-columns: auto 280px;
    }
}

.journey-card__content {
    padding: 40px;
    grid-row: 2;

    @media (min-width: 1280px) {
        grid-row: auto;
    }
}

.journey-card__image {
    background-size: cover;
    min-width: 40%;
    grid-row: 1;
    height: 120px;

    @media (min-width: 1280px) {
        height: auto;
        grid-row: auto;
    }
}

.journey-card__details {
    margin-bottom: var(--grid-gap);
}

.journey-card__title {
    color: var(--color-grey-900);
}

.journey-card__summary {
    color: var(--color-grey-800);
}

.journey-card__days {
    position: absolute;
    top: calc(var(--grid-gap) / 2);
    right: calc(var(--grid-gap) / 2);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border-radius: 60px;
    background-color: var(--color-white);
}

.journey-card__days-count {
    color: var(--color-grey-900);
    font-size: 24px;
    font-weight: bold;
    line-height: 1;
}

.journey-card__days-text {
    color: var(--color-grey-800);
    font-size: 14px;
}
</style>
